export const ACCOUNT_LINK_WITH_CODE_FORM_TEXT = {
  'account_link_with_code_form.title': {
    'en-GB': 'Verify it’s your Moonpig account',
    'nl-NL': 'Verifieer dat dit jouw Greetz account is',
  },
  'account_link_with_code_form.description': {
    'en-GB': 'Link your accounts by entering the 6-digit code sent to',
    'nl-NL': 'Koppel je accounts met de 6-cijferige code verzonden naar',
  },
  'account_link_with_code_form.continue_button': {
    'en-GB': 'Link Account',
    'nl-NL': 'Koppel',
  },
}
